<div class="email-check-container relative">
    @if (title) {
        <h3 class="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
            {{ title }}
        </h3>
    }
    
    @if (description) {
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-6">
            {{ description }}
        </p>
    }

    @if (isCheckingEmail()) {
        <div class="absolute inset-0 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm z-10 flex items-center justify-center rounded-lg">
            <div class="flex flex-col items-center gap-3">
                <mat-spinner diameter="40"></mat-spinner>
                <p class="text-sm text-gray-600 dark:text-gray-400">Verificando email...</p>
            </div>
        </div>
    }

    <form [formGroup]="emailForm" class="space-y-4">
        <mat-form-field class="w-full" appearance="outline">
            <mat-label>Email</mat-label>
            <mat-icon matPrefix svgIcon="heroicons_outline:envelope" class="icon-size-5 mr-2"></mat-icon>
            <input 
                matInput 
                type="email"
                formControlName="email"
                placeholder="email@exemplo.com"
                [disabled]="isCheckingEmail() || isVerified()">
            
            @if (isVerified() && !existingUser()) {
                <mat-icon matSuffix svgIcon="heroicons_outline:check-circle" class="text-green-500"></mat-icon>
            }
            
            <mat-error ngx-mat-errors></mat-error>
        </mat-form-field>

        <!-- Erro: usuário existe em outro cliente -->
        @if (errorMessage()) {
            <div class="flex items-center gap-2 p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle" class="text-red-500 icon-size-5"></mat-icon>
                <p class="text-sm text-red-700 dark:text-red-400">{{ errorMessage() }}</p>
            </div>
        }

        <!-- Info: usuário encontrado -->
        @if (existingUser()) {
            <div class="p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
                <div class="flex items-start gap-3">
                    <mat-icon svgIcon="heroicons_outline:information-circle" class="text-blue-500 icon-size-5 mt-0.5"></mat-icon>
                    <div class="flex-1">
                        <p class="text-sm font-medium text-blue-900 dark:text-blue-100">Usuário encontrado</p>
                        <p class="text-sm text-blue-700 dark:text-blue-300 mt-1">
                            <strong>Nome:</strong> {{ existingUser()?.name }}<br>
                            <strong>Email:</strong> {{ existingUser()?.email }}
                            @if (existingUser()?.cpf) {
                                <br><strong>CPF:</strong> {{ existingUser()?.cpf }}
                            }
                        </p>
                    </div>
                </div>
            </div>
        }

        <!-- Sucesso: novo usuário (não encontrado) -->
        @if (emailCheckStatus() === EmailCheckStatus.NOT_FOUND) {
            <div class="p-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg">
                <div class="flex items-start gap-3">
                    <mat-icon svgIcon="heroicons_outline:check-circle" class="text-green-500 icon-size-5 mt-0.5"></mat-icon>
                    <div class="flex-1">
                        <p class="text-sm font-medium text-green-900 dark:text-green-100">Email disponível</p>
                        <p class="text-sm text-green-700 dark:text-green-300 mt-1">
                            Este email não está cadastrado. Um novo usuário será criado.
                        </p>
                    </div>
                </div>
            </div>
        }

        <!-- Botões -->
        <div class="flex justify-end gap-2 pt-4">
            @if (showCancelButton) {
                <button 
                    mat-stroked-button 
                    type="button"
                    (click)="onCancelClick()"
                    [disabled]="isCheckingEmail()">
                    Cancelar
                </button>
            }
            
            @if (isVerified()) {
                <button 
                    mat-flat-button 
                    color="primary"
                    type="button"
                    (click)="onProceedClick()">
                    Próximo
                    <mat-icon svgIcon="heroicons_outline:arrow-right" class="icon-size-4 ml-1"></mat-icon>
                </button>
            } @else {
                <button 
                    mat-flat-button 
                    color="primary"
                    type="button"
                    (click)="onCheckEmail()"
                    [disabled]="emailForm.invalid || isCheckingEmail() || emailCheckStatus() === EmailCheckStatus.EXISTS_DIFFERENT_CLIENT">
                    @if (isCheckingEmail()) {
                        <mat-spinner diameter="20" class="mr-2"></mat-spinner>
                        Verificando...
                    } @else {
                        {{ verifyButtonText }}
                    }
                </button>
            }
        </div>
    </form>
</div>

